import { showKeys, shows } from '../shared'

export function IndexPage() {
  return (
    <div className="grid place-content-center h-screen text-center">
      <div className="mb-32 max-w-[40ch]">
        <h1 className="text-5xl font-medium mb-8">Find That Line</h1>
        <p className="text-lg">
          Ever needed to find a line from a TV show? You've come to the right place!
        </p>
        <h2 className="mt-8 mb-2 text-2xl">Shows</h2>
        <ul className="my-2 space-y-1">
          {showKeys.map((key) => {
            const name = shows[key]
            return (
              <li key={name}>
                <a className="text-blue-500 text-lg" href={`/${key}`}>
                  {name}
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
